import client from './client.js';

// Meus Resultados — busca/ordenação/filtro resolvidos no servidor
export const listResults = async ({ q, sort, category, orderId } = {}) => {
  const params = {};
  if (q) params.q = q;
  if (sort) params.sort = sort;
  if (category) params.category = category;
  if (orderId) params.order_id = orderId;
  const { data } = await client.get('/results', { params });
  return data;
};
